export default (string) => string.replace(/[&/\\#,+()$~%.'":*?<>{}\s]/g, '-').toLowerCase();
